
import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function HotelIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 30.24 35.12">
      <path d="M29.62 33.88h-1.5V4h1a1 1 0 001-1V1a1 1 0 00-1-1h-28a1 1 0 00-1 1v2a1 1 0 001 1h1v29.88H.62a.62.62 0 000 1.24h29a.62.62 0 100-1.24zM1.38 2.75v-1.5h27.5v1.5zm10.37 31v-3.57a3.64 3.64 0 017.27 0v3.56zm3.63-8.36a4.84 4.84 0 00-4.88 4.8v3.57H3.38V4.25h23.5v29.5h-6.61v-3.57a4.85 4.85 0 00-4.89-4.8z"/>
      <path d="M12.12 7h-4a1 1 0 00-1 1v5a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1zm-.24 5.75h-3.5v-4.5h3.5zm.24 3.25h-4a1 1 0 00-1 1v5a1 1 0 001 1h4a1 1 0 001-1v-5a1 1 0 00-1-1zm-.24 5.75h-3.5v-4.5h3.5zM18.12 14h4a1 1 0 001-1V8a1 1 0 00-1-1h-4a1 1 0 00-1 1v5a1 1 0 001 1zm.26-5.75h3.5v4.5h-3.5zM23.12 22v-5a1 1 0 00-1-1h-4a1 1 0 00-1 1v5a1 1 0 001 1h4a1 1 0 001-1zm-1.24-.25h-3.5v-4.5h3.5z"/>
    </SvgIcon>
  )
}
export default HotelIcon
